

export const BASE_URL = 'https://api.cvms.care.or.tz'
export const NOTIFICATIONS_HEADINGS = ["Date","Title","Content","Status"]
export const REQUESTS_HEADINGS = ["Request Date","Required Date","Request type","Requestor","Status","Project","Fund Code"]
export const USERS_HEADINGS =["Username", "E-mail", "Phone", "Name", "Position", "Department", "Region", "Status"]